import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { H2 } from 'components/core/Typography';
import { Button, MarkdownWrapper } from 'components/atoms';
import { Container } from 'components/core/Page';
import { UnitSizeComparison } from 'components/molecules';
import './SizeComparisonSection.scss';
import unitSizeImage from 'assets/images/psp/sizeComparisionDefault.png';
import classNames from 'classnames';

export function SizeComparisonSection({ content, storageData }) {
	const {
		title,
		description,
		image = unitSizeImage,
		showImage = true,
		contentdec,
		contentAlign,
		tabAlign = 'center',
		hideActiveIndicator = false,
	} = content;

	const [selectedSize, setSelectedSize] = useState(storageData[0]?.size);

	return (
		<section
			className={`vehicle-storage-section${!showImage ? ' no-header-image' : ''}`}
		>
			<Container>
				{showImage && <UnitSizeComparison icon={image} />}
				<div className="vehicle-storage-content">
					<H2>{title}</H2>
					<MarkdownWrapper
						className="vehicle-dec"
						content={[{ value: description }]}
					/>
				</div>

				<div className="centered-square-box">
					<div
						className={classNames(
							'storage-buttons',
							tabAlign,
							hideActiveIndicator && 'hide-active-indicator',
						)}
					>
						{storageData.map(({ size }) => (
							<Button
								key={size}
								className={classNames(
									'storage-button',
									selectedSize === size ? 'active' : '',
								)}
								onClick={() => setSelectedSize(size)}
							>
								{size}
							</Button>
						))}
					</div>
					{storageData.map(({ size, heading, desc }) => (
						<div
							key={size}
							className={classNames(
								'storage-description',
								selectedSize === size ? 'active' : 'hidden',
							)}
						>
							<span className="storage-heading">{heading}</span>
							<MarkdownWrapper
								content={desc.map((point) => ({
									value: point,
								}))}
							/>
						</div>
					))}
				</div>
				<MarkdownWrapper
					content={[{ value: contentdec }]}
					componentProps={{ color: 'black' }}
					className={contentAlign || 'text-left'}
				/>
			</Container>
		</section>
	);
}

SizeComparisonSection.propTypes = {
	content: PropTypes.shape({
		title: PropTypes.string.isRequired,
		description: PropTypes.string,
		image: PropTypes.string,
		contentdec: PropTypes.string,
		contentAlign: PropTypes.string,
		showImage: PropTypes.bool,
		tabAlign: PropTypes.oneOf(['left', 'center', 'right']),
		hideActiveIndicator: PropTypes.bool,
	}).isRequired,
	storageData: PropTypes.arrayOf(
		PropTypes.shape({
			size: PropTypes.string.isRequired,
			heading: PropTypes.string,
			desc: PropTypes.arrayOf(PropTypes.string).isRequired,
		}),
	).isRequired,
};
export default SizeComparisonSection;
